import {Component, Input} from '@angular/core';

@Component({
  selector: 'pl-ineligibility-overlay',
  templateUrl: './ineligibility-overlay.component.html',
  styleUrls: ['./ineligibility-overlay.component.scss']
})
export class IneligibilityOverlayComponent {
  @Input() mode: 'fill_in' | 'select' | 'sign' = 'fill_in';
  constructor() { }
}
